import styled from 'styled-components';

import { Carousel } from '@xing-com/carousel';
import { EditorStyled } from '@xing-com/crate-articles-article-editor';
import { Frame } from '@xing-com/crate-lebenslauf-xinglets';
import { Divider } from '@xing-com/divider';
import { mediaWideNavless, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  spaceM,
  spaceL,
  spaceXL,
  spaceXXL,
  space3XL,
  space4XL,
  space5XL,
} from '@xing-com/tokens';
import { BodyCopy, Hero, Headline } from '@xing-com/typography';

export const StyledHero = styled(Hero)`
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;

export const StyledDescription = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};
`;

export const StyledArticlesHeadline = styled(Headline)`
  margin: ${spaceXXL} 0 ${spaceM};
`;

export const StyledArticlesDescription = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;

export const StyledCarousel = styled(Carousel)`
  margin-bottom: ${spaceXXL};

  @media (max-width: 1024px) {
    margin: 0 -${spaceL} ${spaceXXL} -${spaceL};
    padding-left: ${spaceL};
    padding-right: ${spaceL};
  }
`;

export const StyledDivider = styled(Divider)`
  margin: ${space3XL} 0 ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin: ${spaceXXL} 0 ${space3XL};
  }
`;

export const StyledFrame = styled(Frame)`
  max-width: calc(936px + ${space4XL} + ${space4XL}) !important;
  padding-top: ${space4XL} !important;

  @media ${mediaWideNavless} {
    padding-top: ${space5XL} !important;
  }
`;

export const StyledCover = styled.img`
  width: 100%;
`;

export const EditorContent = styled.div`
  ${EditorStyled.EditorStyle}
`;
